import {Settings} from '../Settings';
import {$window, $body} from '../Constants';
import Menu from './Menu';
import Header from './Header';

/**
 * Implementation of Menu for Horizontal SubMenu Navigation
 */
class HorizontalSubMenu extends Menu {
  constructor($element) {
    super($element);

    this.$menu = this.$element.find('ul.level-1');
    this.scrolledAt = 0;
    this.currentTopValue = 0;
  }

  onReady() {
    super.onReady();

    this.updateScrolledAt();
    this.toggleScrolled();

    $(Settings.sliderId).find('img').first().on('load', $.proxy(function (e) {
      this.updateScrolledAt();
      this.scrolledAt = Math.max(this.scrolledAt, $(e.target).height());
      this.toggleScrolled();
    }, this));
  }

  onResize() {
    super.onResize();

    this.toggleScrolled();
  }

  onScroll() {
    this.toggleScrolled();
  }

  /**
   * Toggle the subMenus "scrolled" state
   */
  toggleScrolled() {
    if (Settings.fixedHorizontalSubMenu) {
      // activate scrolled state when Header docks on the subMenu
      this.$element.toggleClass('scrolled', $window.scrollTop() >= this.scrolledAt);
      this.$element.css('height', this.$menu.height());
      // set top value for fixed menu
      this.adjustTopValue();
    }
  }

  adjustTopValue() {
    let top = Header.getHeight();

    if (Settings.hideMetaBarOnScrolled) {
      if (Header.isScrolled) {
        top -= Header.metaBarHeight;
      }
    }

    if (this.currentTopValue !== top) {
      this.currentTopValue = top;
      this.$menu.css('top', top);
    }
  }

  updateScrolledAt() {
    let scrolledAt = this.$element.offset().top - Header.getHeight();

    if (Settings.hideMetaBarOnScrolled) {
      if (Header.isScrolled) {
        scrolledAt += Header.metaBarHeight;
      }
    }

    this.scrolledAt = scrolledAt;
  }
}

export default (new HorizontalSubMenu($body.find('.menu-sub')));
